export default __webpack_public_path__ + "static/media/IMG-20240729-WA0024.9c66e394.jpg";